import { render, staticRenderFns } from "./DashboardProjectCard.vue?vue&type=template&id=106851ee&scoped=true&"
import script from "./DashboardProjectCard.vue?vue&type=script&lang=js&"
export * from "./DashboardProjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106851ee",
  null
  
)

export default component.exports